import React, { FC, memo, useContext, useMemo } from 'react'
import { ScreenContext } from 'react-components'

import { Container, DestinationContainer, InnerContainer } from './styles'
import {
    CMSPopularDestinationTransport,
    PopularDestinationsSectionTransport,
    PopularDestinationTransport,
} from '../../../transports/region-landing-page-transport'
import { Subtitle, Title, TitleContainer } from '../common/styles'
import BestDestinationCard from './destination-card'
import { useResponsiveValue } from '../../../hooks/responsive'
import { Slide } from 'pure-react-carousel'
import { StyledCarouselProvider, StyledSlider } from '../../common/listing-card-section/styles'

interface BestDestinationsProps {
    popularDestinationsSection: PopularDestinationsSectionTransport
    cmsPopularDestinationsSection: CMSPopularDestinationTransport
}

const breakpoints = [
    { query: '(max-width: 399px)', value: 2.2 },
    { query: '(min-width: 400px) and (max-width: 479px)', value: 2.6 },
    { query: '(min-width: 480px) and (max-width: 519px)', value: 2.8 },
    { query: '(min-width: 520px) and (max-width: 639px)', value: 3.5 },
    { query: '(min-width: 640px) and (max-width: 767px)', value: 3.9 },
    { query: '(min-width: 768px) and (max-width: 1023px)', value: 4.6 },
    { query: '(min-width: 1024px)', value: 6 },
]

const BestDestinationsSection: FC<BestDestinationsProps> = ({
    popularDestinationsSection,
    cmsPopularDestinationsSection,
}) => {
    const { heading, subheading, popularDestinations: regions } = popularDestinationsSection
    const { isDesktop } = useContext(ScreenContext)

    const popularDestinationSectionHeading = cmsPopularDestinationsSection?.heading ?? heading

    const destinationItems = useMemo(
        () =>
            regions.map((region: PopularDestinationTransport, index) =>
                !isDesktop ? (
                    <Slide key={region.title} index={index}>
                        <BestDestinationCard {...region} />
                    </Slide>
                ) : (
                    <BestDestinationCard key={region.url} {...region} />
                ),
            ),
        [regions, isDesktop],
    )

    const visibleSlides = useResponsiveValue(breakpoints, 1.5)
    const dragStep = Math.floor(visibleSlides)

    return (
        <Container id="best-destinations">
            <TitleContainer>
                <Title>{popularDestinationSectionHeading}</Title>
                <Subtitle>{subheading}</Subtitle>
            </TitleContainer>
            <InnerContainer>
                {isDesktop ? (
                    <DestinationContainer>{destinationItems}</DestinationContainer>
                ) : (
                    <StyledCarouselProvider
                        totalSlides={destinationItems.length}
                        visibleSlides={visibleSlides}
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        isIntrinsicHeight
                        lockOnWindowScroll
                        dragStep={dragStep}
                        step={dragStep}
                    >
                        <StyledSlider>{destinationItems}</StyledSlider>
                    </StyledCarouselProvider>
                )}
            </InnerContainer>
        </Container>
    )
}

export default memo(BestDestinationsSection)
